import React from 'react';

import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import { ListGroupItem } from 'react-bootstrap';

import PageTitleNew from 'components/ui/PageTitleNew';
import { useContext } from 'components/Common/PolicyTemplates/Context';
import Item from './Item';

export default function Main() {
  const { dispatch, actions, state } = useContext();

  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }

    actions.move(
      dispatch,
      state.templates,
      result.source.index,
      result.destination.index,
    );
  };

  return (
    <div className="wrapper_assestment invite_wrapper">
      <PageTitleNew title="Policy Categories" />

      <div className="ibox-content mt20">
        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId="droppable">
            {(provided, snapshot) => (
              <>
                <ul
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                  className="list-group"
                >
                  {state.templates == null && (
                  <ListGroupItem align="center">Please, wait ...</ListGroupItem>
                  )}
                  {state.templates
                  && state.templates.map((item, index) => (
                    <Item key={item.id} index={index} item={item} />
                  ))}
                </ul>
                {provided.placeholder}
              </>
            )}
          </Droppable>
        </DragDropContext>
      </div>
    </div>
  );
}
